import { Component } from '@angular/core';
import {LeaseDetailService} from "@modules/private/lease/data/services/view/lease-detail.service";

@Component({
  selector: 'app-lease-settlement',
  templateUrl: './lease-settlement.component.html',
  styleUrls: ['./lease-settlement.component.scss']
})
export class LeaseSettlementComponent {
  constructor(
    public leaseDetailService: LeaseDetailService
  ) {
  }

  get e() {
    return this.leaseDetailService.entitySettlement
  }
}
